package com.milta.feature.auth.data.remote.dto

import com.milta.feature.auth.domain.entity.UserRole
import kotlinx.serialization.Serializable

/**
 * Error response from the Milta API.
 *
 * Format returned by the backend (`GlobalExceptionHandler`, ProblemDetails.Extensions
 * flattens to root — not nested):
 * ```json
 * { "status": 409, "code": "error.conflict.phone_number" }
 * ```
 */
@Serializable
data class ApiError(
    val status: Int? = null,
    val code: String? = null,
    val role: UserRole? = null,
    val scope: SubscriptionAccessScope? = null,
)
